export default "__VITE_PUBLIC_ASSET__4dbbdc8f__"